export const EXPORT_CANCELLED = 'export_cancelled'
export const POLL_INTERVAL = 500 // 0.5s
export const POLL_MAX_ATTEMPTS = 241 // 2minutes of attempted polling